import {Injectable} from '@angular/core';
import {VisbosService} from "../../core/visbos-core/graphql/visbos.service";
import {Apollo, ApolloQueryObservable} from "apollo-angular";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../shared/redux-store";
import {SessionActions} from "../../shared/actions";
import gql from "graphql-tag";
import {addressFragments} from "../../core/visbos-core/services/address.service";
import {ApolloQueryResult} from "apollo-client";
import {Observable} from "rxjs";
import {
  AddClientMutation,
  DeleteClientMutation,
  FetchClientsQuery,
  UpdateClientMutation
} from "../../shared/graphql/graphql.types";

export const clientFragments = {
  client: gql`
    fragment ClientFields on Client {
      cuid created_at updated_at is_editable
      label name
      administration_unit {cuid label}
      address {...AddressFields}
      billing_address {...AddressFields}
      identities {cuid label ean}
      business_relations {cuid label}
      account {cuid label account_name account_number clearing_account_number}
    }
    ${addressFragments.address}
  `
};

export const fetchClientsQuery = gql`
  query FetchClients($adminUnitCuid: String, $cuid: String) {
    clients(adminUnitCuid: $adminUnitCuid, cuid: $cuid) {
      ...ClientFields
    }
  }
  ${clientFragments.client}
`;

export const addClientMutation = gql`
  mutation AddClient($clientData: ClientInput!, $relationsData: [ClientBusinessRelationInput]) {
    addClient(clientData: $clientData, businessRelationsDataInput: $relationsData) {
      ...ClientFields
    }
  }
  ${clientFragments.client}
`;

export const updateClientMutation = gql`
  mutation UpdateClient($cuid: String!, $clientData: ClientInput!, $relationsData: [ClientBusinessRelationInput]) {
    updateClient(cuid: $cuid, clientData: $clientData, businessRelationsDataInput: $relationsData) {
      ...ClientFields
    }
  }
  ${clientFragments.client}
`;

export const deleteClientMutation = gql`
  mutation DeleteClient($cuid: String!) {
    deleteClient(cuid: $cuid)
  }
`;

@Injectable()
export class ClientService extends VisbosService {

  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  //TODO: Migrate Apollo
  getClients(adminUnitCuid?: string): ApolloQueryObservable<FetchClientsQuery> {
    return this.fetchItems({
      query: fetchClientsQuery,
      variables: {
        adminUnitCuid: adminUnitCuid || this.activeAdminUnitCuid$
      }
    });
  }

  //TODO: Migrate Apollo
  addClient(clientData, relationsData?): Observable<ApolloQueryResult<AddClientMutation>> {
    return this.mutate({
      mutation: addClientMutation,
      variables: {
        clientData: clientData,
        relationsData: relationsData
      },
      refetchQueries: ['FetchClients']
    })
  }

  //TODO: Migrate Apollo
  updateClient(cuid: string, clientData, relationsData?): Observable<ApolloQueryResult<UpdateClientMutation>> {
    return this.mutate({
      mutation: updateClientMutation,
      variables: {
        cuid: cuid,
        clientData: clientData,
        relationsData: relationsData
      }
    })
  }

  //TODO: Migrate Apollo
  deleteClient(cuid: string): Observable<ApolloQueryResult<DeleteClientMutation>> {
    return this.mutate({
      mutation: deleteClientMutation,
      variables: {
        cuid: cuid
      },
      refetchQueries: ['FetchClients']
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/crm/services/client.service.ts